import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import { useImmer } from 'use-immer';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';

import MUIDataTable from 'mui-datatables';
import 'react-block-ui/style.css';

import { Grid } from '@material-ui/core';
import { StateContext, DispatchContext } from '../../../context/Provider';

const Roles = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalDispatch } = appDispatch; 

    const [state, setState] = useImmer({
        isLoading: false,
        roles: []
    });

    const [columns, setColumns] = useState([
        {   
            label: "#", 
            name: "id", 
            options: {
                setCellProps: () => ({ style: { width: "5%" }})
            } 
        },
        { label: "Name", name: "name" },
        { label: "Created At", name: "created_at" },
    ]);

    const [options, setOptions] = useState({
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        rowsPerPage: 10,
        selectableRows: false,
        textLabels: {
            body: {
                noMatch: 'Loading.. Please Wait'
            }
        }
    });

    async function fetchRoles() {
        try {
            const response = await axiosConfig.get(`/roles`); 
            const { data } = response.data;

            console.log(data);
            setState(draft => {draft.roles = data});

        } catch (e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {
        console.clear();
        globalDispatch({type: 'setIsLoading', value: true});
        const source = axiosConfig.CancelToken.source();

        fetchRoles();

        return () => {
            source.cancel();
        }

    }, []);
    
    return (
        <ResponsiveLayout>
            <Grid container component="main">
                <Grid item xs={12} sm={12} md={12} lg={8} xl={6}>
                    <MUIDataTable 
                        title={"List of Roles"} 
                        data={state.roles} 
                        columns={columns} 
                        options={options} 
                    />
                </Grid>
            </Grid>
        </ResponsiveLayout>
    )
}

export default Roles;